import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { Subscription } from 'rxjs/Subscription';

import { MessageService } from 'primeng/components/common/messageservice';

import { AcoesEmmiter, Contrato } from '../../../base/vo/contrato';
import { AdminContratosService } from '../admin-contratos.service';
import { ModalExcluirComponent } from './modal-excluir/modal-excluir.component';


@Component({
  selector: 'app-admin-contratos-lista',
  templateUrl: './admin-contratos-lista.component.html',
  styleUrls: ['./admin-contratos-lista.component.scss']
})
export class AdminContratosListaComponent implements OnInit, OnDestroy {

  @ViewChild('modalExcluir')
  public modalExcluir: ModalExcluirComponent;

  public nPagina: number;
  public totalItens: number;
  public nItemsPerPage = 10;
  public paginaAtual = 1;
  public loading = true;
  public contratos: Contrato[];
  public contratoId: number;
  public contratoTitle: string;

  private subs: Subscription[] = [];

  constructor(
    public adminContratosService: AdminContratosService,
    public messageService: MessageService,
    public route: ActivatedRoute,
    public router: Router,
  ) { }

  ngOnInit() {
    this.getContratos(0);
  }

  ngOnDestroy() {
    this.subs.forEach((subscription) => subscription.unsubscribe());
  }

  getContratos(page: number) {
    this.loading = true;
    this.adminContratosService.getContratos(page, this.nItemsPerPage).subscribe(
      (response) => {
        this.contratos = response.documentos;
        this.totalItens = response.totalResultados;
        this.nPagina = response.paginaAtual + 1;
      },
      (errorResponse) => {
        console.log(errorResponse);
      }
    ).add(() => this.loading = false);
  }

  // Paginação
  pageChanged(page: number) {
    this.paginaAtual = page;
    this.getContratos(page - 1);
  }

  validPage(page: number) {
    if (page > this.nPagina) {
      return this.paginaAtual--;
    }
    return this.paginaAtual;
  }

  public actionClick(acoesEmmiter: AcoesEmmiter) {
    if (acoesEmmiter.action === 0) {
      this.router.navigate(['/admin/contratos/visualizar', acoesEmmiter.contratoId]);
    }

    if (acoesEmmiter.action === 1) {
      this.router.navigate(['/admin/contratos/editar', acoesEmmiter.contratoId]);
    }

    if (acoesEmmiter.action === 2) {
      this.router.navigate([`/admin/contratos/vincular/`, acoesEmmiter.contratoId]);
    }

    if (acoesEmmiter.action === 3) {
      this.contratoId = acoesEmmiter.contratoId;
      this.contratoTitle = acoesEmmiter.contratoTitle;
      this.modalExcluir.openDialog();
    }
  }

  excluirNao() {
    this.modalExcluir.closeDialog();
    this.contratoId = null;
    this.contratoTitle = null;
  }

  excluirSim() {
    this.modalExcluir.loading = true;
    this.subs.push(
      this.adminContratosService.deleteContrato(this.contratoId).subscribe(
        response => {
            this.modalExcluir.loading = false;
            this.modalExcluir.closeDialog();
            this.messageService.add({ severity: 'success', summary: 'Documentos', detail: 'Documento excluído com sucesso!' });
            this.getContratos(this.validPage(this.paginaAtual) - 1);
        },
        errorResponse => {
          this.modalExcluir.loading = false;
          this.modalExcluir.closeDialog();
          this.messageService.add({ severity: 'error', summary: 'Erro', detail: errorResponse.error.mensagem });
        })
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/components/admin/contratos/admin-contratos-lista/admin-contratos-lista.component.ts